module.exports = __webpack_public_path__ + "img/icon-success-w.8c2c4028.svg";